/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, {useEffect, useState} from 'react';
// material
import { SectionGroupV2 } from 'material/expandablesection/v2'
import { SingleSelectDropDown, Tip } from '@insticator/insticator-ui'
import { ReactComponent as KudoIcon } from 'assets/icons/kudo.svg'
import { ReactComponent as WarningIcon } from 'assets/icons/error-circle.svg'
// styles
import injectSheet from 'react-jss'
import styles from './commentvolume_styles'
import PreviewConfig from '../../previewconfig/previewconfig';
import Space from 'material/space/space';

const commentVolumeOptions = [
  { name: 'Low comment volume', value: 'LOW', kudos: 600, qualifier: 'Less than 20 monthly comments'},
  { name: 'Medium comment volume', value: 'MEDIUM', kudos: 200, qualifier: '20-99 monthly comments'},
  { name: 'High comment volume', value: 'HIGH', kudos: 100, qualifier: 'Greater than 100 monthly comments'}
]

const commentVolumesMap = {
  LOW: commentVolumeOptions[0],
  MEDIUM: commentVolumeOptions[1],
  HIGH: commentVolumeOptions[2]
}
/* ========== ~~~~~~~~~~ COMMENTING CONFIG V2: ADMIN SECTION : COMMENT VOLUME ~~~~~~~~~~ ========== */
const CommentVolume = injectSheet(styles)((props) => {

  const { commentVolume, onChange } = props
  const [selectedCommentVolume, setCommentVolume] = useState(commentVolumesMap[commentVolume])

  useEffect(() => {
    setCommentVolume(commentVolumesMap[commentVolume])
  }, [commentVolume])

  const handleSelectCommentVolume = opt => {
    setCommentVolume(opt)
    onChange('commentVolume', opt.value)
  }

  return (
    <SectionGroupV2 
      klass={`${props.classes.commentvolume} commentvolume`}
      title={'Kudos Progression'} 
      description={<span>Select the volume of comments your site receives per article. <Tip space={'none'} icon={'question-circle'} content={`For example, if the number of comments you receive per article is high, we reduce the Kudos points users gain to balance how quickly they attain status ranks and unlockable achievements.`} label={''} /></span>}
      indented
    >
      <div className='explainer'>
        <ul>
          <li>Kudos are points users achieve for performing certain actions like commenting, replying, reacting, and more.</li>
          <li>Kudos determine how a user progresses in status as they use the product, earning different ranks like "Rising Star", "Top Commenter", "Hall of Famer", and more.</li>
          <li>Kudos also accrue and unlock achievement badges for milestones like "Post 100 Comments", "Earn 25 Followers", and more.</li>
        </ul>
        <Space alignItems={'center'} gap={16}>
          <SingleSelectDropDown 
            name={selectedCommentVolume.name} 
            searchable={false} 
            onSelect={handleSelectCommentVolume}
            items={commentVolumeOptions}
          />
          <span className='qualifier'>{selectedCommentVolume.qualifier}</span>
        </Space>
        <Space klass={'warningmessage'} alignItems={'center'}>
          <WarningIcon className='warningicon' /> <p>Changing this value will <strong>not</strong> affect previously earned Kudos. <Tip space={'none'} icon={'question-circle'} content={<span>We do not retroactively change Kudos, Statuses, or Achievements earned by users. Users would be frustrated by losing what they rightfully gained. Instead, if a different comment volume is selected, only future Kudos accrual will be affected.</span>} label={''} /></p>
        </Space>
      </div>
      <PreviewConfig>
        <Space alignItems={'center'} direction={'column'}>
          <Space alignItems={'center'} justifyContent={'center'} klass={'kudostip'}>
            <KudoIcon />
            <span>+{selectedCommentVolume.kudos} kudos</span>
          </Space>
          <div className='button'>Post</div>
        </Space>
      </PreviewConfig>
    </SectionGroupV2>
  )
})

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default CommentVolume;